import React from 'react'
import { Typography, Grid, Button, Link} from '@mui/material';
import colors from '../../colors'
import { ReactComponent as IconEmailConfirmation } from '../../../icons/emailConfirmation.svg';
import Lottie from "lottie-react";
import emailConfirmationAnimation from '../../../icons/lottieAnimations/emailConfirmation.json'
import {selectRegistrationState,  incrementCurrentRegistrationStep, setIsEmailSuccessfullyResent} from '../../../features/registration/registrationSlice'
import {useSelector ,useDispatch } from 'react-redux';
import {sendGeneralRequest} from '../../../features/generalRequest'
import {setGeneralMessage} from '../../../features/global/globalDataSlice';
import { makeStyles } from '@mui/styles';
import { texts } from '../../general/texts';
import Timer from '../../general/Timer';

const ThirdRegistrationStep = (props) => 
{
    const dispatch = useDispatch()
    const registrationSliceState = useSelector(selectRegistrationState)
    const [shouldDisplayResendMail, setShouldDisplayResendMail] = React.useState(false)
    const requestData = 
    {
        token : registrationSliceState.token
    } 

    React.useEffect(()=>{
         
        const intervalId = setInterval(() => {
            if(registrationSliceState.shouldRepeatEmailRequest === true)        
            {
                dispatch(sendGeneralRequest({request: {_request: requestData}, baseUrlKey:'auth', endpoint:'CheckEmailValidation'}))
            }   
        },5000)    

        return () => clearInterval(intervalId)    
   
    },[registrationSliceState.shouldRepeatEmailRequest])

    React.useEffect(()=>{
        if(registrationSliceState.isEmailSuccessfullyResent)
        {
            dispatch(setGeneralMessage({type: 'success', message: texts["message-email-resend-success"]}))
            dispatch(setIsEmailSuccessfullyResent(false))
            setShouldDisplayResendMail(false)
        }    
    },[registrationSliceState.isEmailSuccessfullyResent])

    const handleButtonClick = () => 
    {
        dispatch(incrementCurrentRegistrationStep())
    }

    const resendEmail = () => 
    {
        dispatch(sendGeneralRequest({request: {_request: {token: registrationSliceState.token}}, baseUrlKey:'auth', endpoint: 'SendConfirmationLink'}))
    }

    const useStyles = makeStyles({
        header:{
            color:colors.orange,
            fontFamily:'GerberaLight',
            marginBottom: '3%'
        },
        text:{
            color:colors.gray,
            fontFamily:'GerberaLight'
        },
        link:{
            fontFamily:'GerberaBold',
            color:colors.darkBlue
        },
        button:{
            background:colors.gradientOrange,
            color:colors.white,
            width:'12%',
            fontFamily:'GerberaBold',
            "&:disabled":{background:colors.gradientOrange, color:colors.white,'@media (max-width: 899px)':{width:'40%'}}
        }
    })

    const classes = useStyles()

    return(
        <Grid container>
            <Grid item md={12} xs={12} mt={-3}>
                <Typography className={classes.header} variant="h5" >{texts["title-email-validation"]}</Typography>  
            </Grid>
            <Grid container justifyContent={'center'} item md={12} xs={12} marginBottom={7}>
                {registrationSliceState.shouldEmailAnimationPlay ? <Lottie animationData={emailConfirmationAnimation} loop={false} autoplay={true}/> : <IconEmailConfirmation/>}
            </Grid>
            <Grid item md={12} xs={12}>
                <Typography variant="caption" className={classes.text}>{texts["prompt-email-validation"]}</Typography>
            </Grid>
            <Grid item md={12} xs={12}>
                {shouldDisplayResendMail
                ? <Link onClick={resendEmail} className={classes.link} component="button" underline="none" variant="overline">{texts["message-resend-email"]}</Link>
                :<Grid container item md={12} xs={12} justifyContent={'center'} mt={2} >
                    <Typography sx={{fontFamily:'GerberaBold', color: colors.darkBlue, marginRight:1}}>{texts["message-resend-email-timer"]}</Typography>
                    <Timer duration={2 * 60 * 1000} onTimerCompleted={(value) => setShouldDisplayResendMail(value)}/>
                </Grid>

                }
                
            </Grid>
            <Grid item md={12} xs={12} pt={5}>
                <Button className={classes.button} disabled={registrationSliceState.isLoading || registrationSliceState.shouldRepeatEmailRequest ? true : false}  onClick={handleButtonClick}>{texts["button-continue"]}</Button>
            </Grid>                           
        </Grid>
    );
}

export default ThirdRegistrationStep